/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var RequestListIcon = createIcon("RequestListIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#F96800';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 30a2 2 0 110 4H22a2 2 0 110-4h12Zm-20 0a2 2 0 110 4 2 2 0 010-4Zm20-8a2 2 0 110 4H22a2 2 0 110-4h12Zm-20 0a2 2 0 110 4 2 2 0 010-4Zm20-8a2 2 0 110 4H22a2 2 0 110-4h12Zm-20 0a2 2 0 110 4 2 2 0 010-4Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.RequestListIcon",
  "replaceColor": true
});